import { hesselViewModels } from '../../lib/view-models';

export const getEquipmentPackagesIncludedInPackage = (
    equipmentPackages: hesselViewModels.EquipmentPackage[],
    includedPackageIdKeys: string[]
): hesselViewModels.EquipmentPackage[] => {
    const filtered = equipmentPackages.filter((e) => {
        return includedPackageIdKeys.includes(e.packageIdKey);
    });
    return filtered;
};

export const isEquipmentIncludedInCheaperPackage = (
    equipment: hesselViewModels.Equipment,
    currentPackage: hesselViewModels.EquipmentPackage,
    allPackages: hesselViewModels.EquipmentPackage[]
): boolean => {
    const otherPackagesWithEquipment = allPackages.filter((p) => {
        return p.equipment.some((eItem) => eItem.id === equipment.id);
    });

    const packagesSortedByCost = otherPackagesWithEquipment.sort((a, b) => {
        return Number(a.cashPrice) - Number(b.cashPrice);
    });

    if (packagesSortedByCost.length > 0) {
        const cheapestPackage = packagesSortedByCost[0];
        if (cheapestPackage.id === currentPackage.id) {
            return false;
        }
    }

    return true;
};
